import dashboard from './dashboard';
import admin from './admin';

import userProfile from './profile';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [dashboard, userProfile, admin]
};

export default menuItems;
